import { Box, Button, Card, Chip, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Grid, Input, InputBase, InputLabel, MenuItem, OutlinedInput, Paper, Popover, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { toast } from 'react-toastify';
import Iconify from 'src/components/iconify'
import { getData, postData, putData, uploadFile } from 'src/webService/webService';
import PaginationComponent from 'src/components/pagination';
import { file_URL } from '../../utils/url'

function GraphicSelfAssigned() {

    const [open, setOpen] = useState(null);
    const UserId = sessionStorage.getItem("userId");
    const [formOpen, setFormOpen] = useState(false);
    const [dailyData, setDailyData] = useState("");
    const [updatedData, setUpdatedData] = useState({});
    const [selectedLeadId, setSelectedLeadId] = useState(null);
    const [selectedLead, setSelectedLead] = useState("");
    const [leadsData, setLeadsData] = useState([]);
    const [view, setView] = useState([]);
    const [allUpdates, setAllUpdates] = useState([]);
    const [scroll, setScroll] = useState('paper');
    const [details, setDetails] = useState(false);
    const descriptionElementRef = useRef(null);
    const [selectedFiles, setSelectedFiles] = useState({})
    const [fileUpload, setFileUpload] = useState(null);
    const [selectedWorkUpdateId, setSelectedWorkUpdateId] = useState(null);
    const [openImage, setOpenImage] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');
    const [totalCount, setTotalCount] = useState(0);
    const [limit, setLimit] = useState(5);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [graphicData, setGraphicData] = useState([]);

    console.log("view", view)

    const [formData, setFormData] = useState({
        projectName: "",
        designType: "",
        colorScheme: "",
        fileFormat: "",
        requirements: "",
        deadline: "",
        status: "",
        comments: "",
        fileUpload: "",
        completionPercentage: "",
        totalDesigns: "",
        completedDesigns: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleOpenMenu = (event, task, id, workUpdateId) => {
        let lead;

        // If task is the full lead object (Admin/Team Leader case)
        if (task && typeof task === 'object') {
            lead = task;
            setSelectedLead(lead);
        }
        // If task is just the ID (Employee case)
        else {
            lead = leadsData.find((data) => data._id === id);
            setSelectedLead(lead);
        }

        if (event?.currentTarget) {
            setOpen(event.currentTarget);
            setSelectedLeadId(id);
            setSelectedWorkUpdateId(workUpdateId);
            setView(lead || task); // Set view to either the lead object or the task data
        }
    };

    const handleCloseMenu = () => {
        setOpen(null);
    };

    const handleOpenDialog = async () => {
        await getAllUpdatesAdmin();
        setDetails(true);
        handleCloseMenu();
    };

    const handleCloseDialog = () => {
        setDetails(false);
    };

    const handleOpen = async () => {
        setFormOpen(true);
        handleCloseMenu();
    }

    const handleClose = () => {
        setFormOpen(false)
    }

    useEffect(() => {
        if (details) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [details]);

    useEffect(() => {
        setUpdatedData({});
    }, [leadsData]);

    const sessionToken = sessionStorage.getItem("Token");
    const role = sessionStorage.getItem("role");
    const roleType = sessionStorage.getItem("roleType");
    const serviceTeamType = sessionStorage.getItem("serviceTeamType");
    const userId = sessionStorage.getItem("userId");


    const getDailyUpdates = async () => {

        try {
            const response = await getData(`dailyworkupdates/user/${UserId}`, {}, sessionToken);
            console.log("Response Daily Updates:", response)
            const results = response?.data;
            console.log("Results:", results)
            setDailyData(results);

        } catch (err) {
            console.error("Error while fetching Graphic Designing Team:", err);
            toast.error(`Failed to load Graphic Designing Team. ${err ? err : ''}`);
        }

    }

    const getAllUpdatesAdmin = async () => {

        const params = {
            page: 1,
            limit: 1000
        }

        try {
            const response = await getData("dailyworkupdates/updates", params, sessionToken);
            console.log("Response Dailyyy Updates:", response)

            const filteredData = response?.data[0]?.paginatedResults?.filter(lead => lead.serviceName === "Graphic Designing");

            console.log("Filtered Data:", filteredData);
            setAllUpdates(filteredData); // Store all data here
            // setView(filteredData);

        } catch (err) {
            console.error("Error while fetching Graphic Designing Team:", err);
            toast.error(`Failed to load Graphic Designing Team. ${err ? err : ''}`);
        }

    }

    const handleFileChange = (event, leadId) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFiles(prev => ({ ...prev, [leadId]: file }));
            handleFileUpload(file, leadId);
        }
    };

    const handleFileUpload = async (fileupload, leadId) => {
        console.log("Fileupload:", fileupload);
        console.log("Is File:", fileupload instanceof File);
        debugger

        const formDataToSend = new FormData();
        formDataToSend.append("file", fileupload);

        try {
            const response = await uploadFile(`files/upload/${selectedLeadId}`, formDataToSend);
            if (response?.status === 200) {
                toast.success("File uploaded successfully!");
                setFileUpload(response?.data);
                setFormData(prevState => ({
                    ...prevState,
                    fileupload: response?.data,
                }));
            } else {
                toast.error("File upload failed!", response?.message);
            }
        } catch (error) {
            console.error("File upload error:", error);
            toast.error(`Error uploading file. ${error ? error : ''}`);
        }
    };

    const postDailyUpdates = async () => {
        debugger
        try {
            // First check if updates exist for this lead
            const checkResponse = await getData(`dailyworkupdates/${selectedLeadId}`, {}, sessionToken);
            const existingUpdates = checkResponse?.data?.map(update => update?.graphicDesignHistory?.map(history => history?.dailyUpdateId));

            const graphicDesignHistory = selectedLead?.graphicDesignHistory?.[0] ||
                selectedLead?.graphicDesignHistory ||
                {};
            const assignedDesigns = selectedLead?.graphicDesignHistory?.[0]?.assignedDesigns;
            const previousCompleted = graphicDesignHistory.completedDesigns || 0;
            const newCompleted = parseInt(formData.completedDesigns, 10) || 0;
            const totalCompleted = previousCompleted + newCompleted;
            const remainingDesigns = assignedDesigns - newCompleted;

            // Get existing lead data or use defaults
            const designType = selectedLead?.graphicDesignHistory?.[0]?.designType ||
                selectedLead?.graphicDesignHistory?.designType ||
                '';
            const requirements = selectedLead?.graphicDesignHistory?.[0]?.requirements ||
                selectedLead?.graphicDesignHistory?.requirements ||
                '';
            const deadline = selectedLead?.graphicDesignHistory?.[0]?.deadline ||
                selectedLead?.graphicDesignHistory?.deadline ||
                '';
            const totalDesigns = selectedLead?.graphicDesignHistory?.[0]?.totalDesigns ||
                selectedLead?.graphicDesignHistory?.totalDesigns ||
                '';

            const amount = selectedLead?.graphicDesignHistory?.[0]?.amount ||
                selectedLead?.graphicDesignHistory?.amount ||
                '';
            const assignedTo = selectedLead?.graphicDesignHistory?.[0]?.assignedTo ||
                selectedLead?.graphicDesignHistory?.assignedTo ||
                '';
            const status = selectedLead?.graphicDesignHistory?.[0]?.completedDesigns === selectedLead?.graphicDesignHistory?.[0]?.totalDesigns ? "Completed" : "In Progress" || '';

            const payLoad = {
                amount,
                assignedTo,
                requirements,
                deadline,
                assignedDesigns: remainingDesigns,
                fileUpload: fileUpload,
                comments: formData.comments,
                totalDesigns,
                completedDesigns: totalCompleted,
                serviceName: "Graphic Designing",
                status: status,
                leadId: selectedLeadId,
                userId: UserId,
            };

            let response;

            if (existingUpdates.length === 0) {
                // POST new update if none exists
                response = await postData('dailyworkupdates', payLoad, sessionToken);
            } else {
                // PUT update existing record
                const updateId = existingUpdates[existingUpdates.length - 1]; // Get first update's ID
                response = await putData(`dailyworkupdates/dailyworkupdates/${updateId}`, payLoad, sessionToken);
            }

            if (response?.status === 200) {
                toast.success("Daily Work Updated Successfully!");
                handleClose();

                // Refresh data based on user role
                if (roleType === "Employee") {
                    getDailyUpdates();
                }
                // Reset form
                setFormData({
                    projectName: "",
                    designType: "",
                    colorScheme: "",
                    fileFormat: "",
                    requirements: "",
                    deadline: "",
                    status: "",
                    comments: "",
                    fileUpload: "",
                    completionPercentage: "",
                    totalDesigns: "",
                    completedDesigns: ""
                });
                setFileUpload(null);
                getAllLeads()
            } else {
                throw new Error(response?.message || "Failed to update Daily Work.");
            }

        } catch (error) {
            console.error("Error:", error);
            toast.error(`${error ? error : ''}` || "Something went wrong. Please try again!");
        }
    };

    const handleLimitChange = (event) => {
        setCurrentPage(1);
        if (currentPage === 1) {
            setLimit(event.target.value)
            getAllLeads(1, event.target.value)
        }
        else {
            setCurrentPage(1);
            setLimit(event.target.value);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage((prev) => prev - 1);
            getAllLeads(currentPage - 1, limit);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage((prev) => prev + 1);
            getAllLeads(currentPage + 1, limit);
        }
    };

    const calculateIndex = (index) => {
        return (currentPage - 1) * limit + index + 1;
    };

    const getAllLeads = async (skip = currentPage) => {
        const parmas = {
            page: skip,
            limit: limit
        }
        try {
            console.log("Fetching users...");
            console.log("Token being sent:", sessionToken);

            const response = await getData(`leads/leads/${userId}`, parmas, sessionToken);
            console.log("Response:", response)

            const responseData = response?.data[0]?.paginatedResults || [];

            setGraphicData(responseData)
            setTotalPages(response.data[0].totalPages);
            setTotalCount(response.data[0].totalCount.totalItems);

        }
        catch (error) {
            console.error("Error fetching users:", error);
        }
    }
    useEffect(() => {
        getAllLeads(currentPage, limit);
    }, [currentPage, limit, roleType]);

    return (
        <>
            <Helmet>
                <title>Self Assigned Graphic Design</title>
            </Helmet>
            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        Self Assigned Graphic Design
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                backgroundColor: "white",
                                borderRadius: "15px",
                                padding: "4px 12px",
                                boxShadow: 1,
                                marginRight: "20px"
                            }}
                        >
                            <Iconify icon="eva:search-fill" />
                            <InputBase
                                placeholder="Search"
                                sx={{ marginLeft: "8px" }}
                            />
                        </Box>
                    </Box>
                </Stack>
                <Card sx={{ padding: 2, boxShadow: 3, backgroundColor: "#fff" }}>
                    <TableContainer component={Paper} sx={{ boxShadow: "none", backgroundColor: "transparent", maxHeight: 350 }}>
                        <Table>
                            <TableHead>
                                <TableCell>S.No</TableCell>
                                <TableCell>Lead</TableCell>
                                <TableCell>Contact</TableCell>
                                <TableCell>Assigned Work</TableCell>
                                <TableCell>Assigned Posters</TableCell>
                                <TableCell>Deadline</TableCell>
                                <TableCell>Completed Pages</TableCell>
                                <TableCell>File</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell></TableCell>
                            </TableHead>
                            <TableBody>
                                {
                                    graphicData.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={7} align="center">
                                                No data found
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        graphicData?.map((task, id) => {
                                            return (
                                                <TableRow key={task?.id}>
                                                    <TableCell align="center">{calculateIndex(id)}</TableCell>
                                                    <TableCell align="center">{task?.name}</TableCell>
                                                    <TableCell align="center">{task?.phone}</TableCell>
                                                    <TableCell align="center">{task?.currentWork?.noOfPosters}</TableCell>
                                                    <TableCell align="center">{task?.currentWork?.comments}</TableCell>
                                                    <TableCell align='center'>{task?.currentWork !== null ? new Date(task?.currentWork?.deadline).toLocaleDateString() : "-"}</TableCell>
                                                    <TableCell align="center">{task?.graphicDesignHistory[0]?.completedDesigns} / {task?.graphicDesignHistory[0]?.totalDesigns}</TableCell>
                                                    <TableCell>
                                                        {task?.graphicDesignHistory[0]?.fileUpload?.path ?
                                                            <img
                                                                src={task?.graphicDesignHistory[0]?.fileUpload?.path
                                                                    ? `${file_URL + encodeURI(task?.graphicDesignHistory[0]?.fileUpload?.path.replace("public/", ""))}`
                                                                    : "#"}
                                                                alt=''
                                                                style={{ maxWidth: "50px", cursor: "pointer" }}
                                                                onClick={() => {
                                                                    const fullImage = task?.graphicDesignHistory[0]?.fileUpload?.path
                                                                        ? `${file_URL + encodeURI(task?.graphicDesignHistory[0]?.fileUpload?.path.replace("public/", ""))}`
                                                                        : "#";
                                                                    setSelectedImage(fullImage);
                                                                    setOpenImage(true);
                                                                }}
                                                            />
                                                            : "-"}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Box position="relative" display="inline-flex">
                                                            <CircularProgress
                                                                variant="determinate"
                                                                value={task?.graphicDesignHistory[0]?.completionPercentage}
                                                            />
                                                            <Box
                                                                top={0}
                                                                left={0}
                                                                bottom={0}
                                                                right={0}
                                                                position="absolute"
                                                                display="flex"
                                                                alignItems="center"
                                                                justifyContent="center"
                                                            >
                                                                <Typography variant="caption" component="div" color="text.secondary">
                                                                    {typeof task?.graphicDesignHistory[0]?.completionPercentage === 'number'
                                                                        ? `${Math.round(task.graphicDesignHistory[0].completionPercentage)}%`
                                                                        : '0%'}
                                                                </Typography>

                                                            </Box>
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Iconify
                                                            icon="material-symbols-light:more-vert"
                                                            sx={{ margin: "auto" }}
                                                            onClick={(event) => handleOpenMenu(event, task, task._id)}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })
                                    )
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <PaginationComponent
                        name={"Services"}
                        totalcount={totalCount}
                        limit={limit}
                        handleLimitChange={handleLimitChange}
                        handlePrevPage={handlePrevPage}
                        handleNextPage={handleNextPage}
                        currentPage={currentPage}
                        totalPages={totalPages}
                    />
                </Card>

                {/* Edit Menu  */}
                <Popover
                    open={Boolean(open)}
                    anchorEl={open}
                    onClose={handleCloseMenu}
                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    PaperProps={{
                        sx: {
                            p: 1,
                            width: 140,
                            '& .MuiMenuItem-root': {
                                px: 1,
                                typography: 'body2',
                                borderRadius: 0.75,
                            },
                        },
                    }}
                >
                    <MenuItem onClick={handleOpenDialog}>
                        <Iconify icon={'material-symbols:visibility'} sx={{ mr: 2 }} />
                        View
                    </MenuItem>

                    <MenuItem onClick={handleOpen}>
                        <Iconify icon={'eva:edit-fill'} sx={{ mr: 1 }} />
                        Work Update
                    </MenuItem>
                </Popover >

                {/* view Dialog  */}
                <Dialog
                    open={details}
                    onClose={handleCloseDialog}
                    scroll={scroll}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                >
                    <DialogTitle id="scroll-dialog-title">
                        <Typography variant="h5" component="div" sx={{ fontWeight: 'bold' }}>
                            Daily Work Updates
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers={scroll === 'paper'}>
                        <DialogContentText
                            id="scroll-dialog-description"
                            ref={descriptionElementRef}
                            component="div"
                        >
                            {!view || Object.keys(view).length === 0 ? (
                                <Box sx={{ p: 3, textAlign: 'center' }}>
                                    <Typography variant="h6" color="text.secondary">No data found</Typography>
                                </Box>
                            ) : (
                                <Box sx={{ p: 1 }}>
                                    <Paper elevation={3} sx={{
                                        p: 2,
                                        backgroundColor: '#ffffff',
                                        borderRadius: 2,
                                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                                        borderLeft: '5px solid #1976d2' // A subtle accent line
                                    }}>{role === 'Admin' ? (
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Project Details
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Name: {view?.name}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Design Type: {view?.graphicDesignHistory?.designType}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Deadline: {new Date(view?.graphicDesignHistory?.deadline).toLocaleDateString()}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Status: <Typography component="span" sx={{
                                                        fontWeight: 'bold',
                                                        color: view?.graphicDesignHistory?.status === 'Completed' ? 'success.main' :
                                                            view?.graphicDesignHistory?.status === 'In Progress' ? 'warning.main' : 'error.main'
                                                    }}>
                                                        {view?.graphicDesignHistory?.status}
                                                    </Typography>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    requirements: {view?.graphicDesignHistory?.requirements}
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Task Progress
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Completed Designs: {view?.graphicDesignHistory?.completedDesigns}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Total Designs: {view?.graphicDesignHistory?.totalDesigns}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="body1">
                                                    Progress: <Typography component="span" sx={{ fontWeight: 'bold', color: '#007bff' }}>
                                                        {view?.graphicDesignHistory?.completionPercentage}%
                                                    </Typography>
                                                </Typography>
                                            </Grid>

                                            {view?.[0]?.graphicDesignHistory?.comments && (
                                                <Grid item xs={12} id="paddingTop">
                                                    <Typography variant="h6" sx={{ mt: 2, mb: 1, color: '#333' }}>
                                                        Comments
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
                                                        {view?.[0]?.graphicDesignHistory?.comments}
                                                    </Typography>
                                                </Grid>
                                            )}

                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Timestamps
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body2" color="text.secondary">
                                                    Created: {new Date(view?.createdAt).toLocaleString()}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body2" color="text.secondary">
                                                    Updated: {new Date(view?.updatedAt).toLocaleString()}
                                                </Typography>
                                            </Grid>
                                        </Grid>) : (<Grid container spacing={2}>
                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Project Details
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Name: {view?.name}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Design Type: {view?.graphicDesignHistory[0]?.designType}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Deadline: {new Date(view?.graphicDesignHistory[0]?.deadline).toLocaleDateString()}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Status: <Typography component="span" sx={{
                                                        fontWeight: 'bold',
                                                        color: view?.graphicDesignHistory[0]?.status === 'Completed' ? 'success.main' :
                                                            view?.graphicDesignHistory[0]?.status === 'In Progress' ? 'warning.main' : 'error.main'
                                                    }}>
                                                        {view?.graphicDesignHistory[0]?.status}
                                                    </Typography>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    requirements: {view?.graphicDesignHistory[0]?.requirements}
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Task Progress
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Completed Designs: {view?.graphicDesignHistory[0]?.completedDesigns}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Total Designs: {view?.graphicDesignHistory[0]?.totalDesigns}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="body1">
                                                    Progress: <Typography component="span" sx={{ fontWeight: 'bold', color: '#007bff' }}>
                                                        {view?.graphicDesignHistory[0]?.completionPercentage}%
                                                    </Typography>
                                                </Typography>
                                            </Grid>

                                            {view?.[0]?.graphicDesignHistory[0]?.comments && (
                                                <Grid item xs={12} id="paddingTop">
                                                    <Typography variant="h6" sx={{ mt: 2, mb: 1, color: '#333' }}>
                                                        Comments
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
                                                        {view?.[0]?.graphicDesignHistory[0]?.comments}
                                                    </Typography>
                                                </Grid>
                                            )}

                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Timestamps
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body2" color="text.secondary">
                                                    Created: {new Date(view?.createdAt).toLocaleString()}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body2" color="text.secondary">
                                                    Updated: {new Date(view?.updatedAt).toLocaleString()}
                                                </Typography>
                                            </Grid>
                                        </Grid>)}
                                    </Paper>
                                </Box>
                            )}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseDialog}>Close</Button>
                    </DialogActions>
                </Dialog>

                {/* work update dialog */}
                <Dialog
                    open={formOpen}
                    onClose={handleClose}
                    scroll={scroll}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                >
                    <DialogTitle id="scroll-dialog-title">Daily Work Update!</DialogTitle>
                    <DialogContent dividers={scroll === 'paper'}>
                        <DialogContentText
                            id="scroll-dialog-description"
                            ref={descriptionElementRef}
                        >
                            <TextField
                                margin="dense"
                                label="Completed Designs"
                                name="completedDesigns"
                                value={formData.completedDesigns}
                                onChange={handleChange}
                                type="number"
                                fullWidth
                            />

                            {/* <TextField
                                margin="dense"
                                label="Status"
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                                select
                                fullWidth
                            >
                                <MenuItem value="Pending">Pending</MenuItem>
                                <MenuItem value="In Progress">In Progress</MenuItem>
                                <MenuItem value="Completed">Completed</MenuItem>
                            </TextField> */}

                            <TextField
                                margin="dense"
                                label="Comments"
                                name="comments"
                                value={formData.comments}
                                onChange={handleChange}
                                multiline
                                fullWidth
                            />
                            <TextField
                                margin='dense'
                                type='file'
                                hidden
                                label="Upload File"
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                onChange={(e) => handleFileChange(e)}
                            >
                            </TextField>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button onClick={postDailyUpdates}>Submit</Button>
                    </DialogActions>
                </Dialog>
            </Container >
        </>
    )
}

export default GraphicSelfAssigned
